import { render, staticRenderFns } from "./batchChildModule.vue?vue&type=template&id=5a4b0478&scoped=true"
import script from "./batchChildModule.vue?vue&type=script&lang=js"
export * from "./batchChildModule.vue?vue&type=script&lang=js"
import style0 from "./batchChildModule.vue?vue&type=style&index=0&id=5a4b0478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b0478",
  null
  
)

export default component.exports